/* Wrenquin Club: member pricing from the next order; one membership per cart.
   DiscountOS remains the authority for the checkout discount. */
(function () {
  'use strict';
  if (window.WQClub) return;
  var source = document.getElementById('wq-club-config');
  if (!source) return;
  var cfg;
  try { cfg = JSON.parse(source.textContent); } catch (e) { return; }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = cfg.cart || { items: [] }, queue = Promise.resolve(), inFlight = null;
  var serial = 0, mutationBusy = false, selected = false;
  function money(cents) { return '$' + (Math.max(0, cents) / 100).toFixed(2); }
  function copy(key, values) {
    var text = cfg.copy[key] || '';
    Object.keys(values || {}).forEach(function (k) { text = text.split('{' + k + '}').join(values[k]); });
    return text;
  }
  function isClub(item) { return String(item.product_id) === String(cfg.productId); }
  function isTee(item) {
    return item.vendor === cfg.vendor && item.requires_shipping === true && item.product_type === 'Graphic Apparel' && !isClub(item);
  }
  function hasClub(c) { return (c.items || []).some(isClub); }
  function member() { return !!cfg.member; }
  function memberPricing() { return member(); }
  function wantsClub() { return selected && cfg.enabled && !member() && !hasClub(cart); }
  function charge() { return wantsClub() ? cfg.price : 0; }
  function setCart(next) {
    cart = next || { items: [] };
    WQBundle.setCart(cart);
    renderBlocks();
    document.dispatchEvent(new CustomEvent('wq:club-change'));
  }
  function request(path, body) {
    return fetch(root + path, {
      method: body ? 'POST' : 'GET', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'Cart request failed');
        return data;
      });
    });
  }
  // Keep one membership in total, even when separate cart lines carry
  // different properties. Re-read line keys from each change response.
  function normalizeClub(current) {
    var changed = false;
    function next(value, attempts) {
      var clubs = (value.items || []).filter(isClub);
      var target = clubs.length > 1 ? clubs[1] : clubs[0];
      if (!target || (clubs.length === 1 && target.quantity === 1)) return Promise.resolve(value);
      if (attempts >= 10) return Promise.reject(new Error('Club quantity could not be normalized'));
      var line = (value.items || []).indexOf(target) + 1;
      var change = { quantity: clubs.length > 1 ? 0 : 1 };
      if (target.key) change.id = target.key;
      else change.line = line;
      changed = true;
      return request('cart/change.js', change).then(function (updated) { return next(updated, attempts + 1); });
    }
    return next(current, 0).then(function (updated) {
      if (changed) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      return updated;
    });
  }
  function sync() {
    if (inFlight) return inFlight;
    // Normalization and all Club additions share one queue, so a background
    // cart refresh cannot race a PDP/upsell/page addition.
    inFlight = mutate(function () { return []; }, false).finally(function () { inFlight = null; });
    return inFlight;
  }
  // Every Club entry point shares this queue. A fresh cart read prevents a
  // second button click from adding a duplicate Club.
  function mutate(makeItems, join) {
    var job = queue.catch(function () {}).then(function () {
      mutationBusy = true; ++serial; renderBlocks();
      return request('cart.js').then(normalizeClub).then(function (current) {
        setCart(current);
        var items = makeItems(current);
        if (join && cfg.enabled && !cfg.member && !hasClub(current)) items.push({ id: cfg.variantId, quantity: 1 });
        if (!items.length) return current;
        return request('cart/add.js', { items: items }).then(function () { return request('cart.js'); }).then(normalizeClub);
      }).then(function (current) { ++serial; setCart(current); return current; })
        .finally(function () { mutationBusy = false; renderBlocks(); });
    });
    queue = job.catch(function () {});
    return job;
  }
  function addTees(ids, includeClub) {
    return mutate(function (current) {
      var hasFull = (current.items || []).some(function (it) { return isTee(it) && it.properties && it.properties._fl_role === 'full'; });
      var grouped = {}, order = [];
      ids.forEach(function (id) {
        var role = hasFull ? 'additional' : 'full'; hasFull = true;
        var key = id + '|' + role;
        if (!grouped[key]) { grouped[key] = { id: id, quantity: 0, properties: { _fl_role: role } }; order.push(key); }
        grouped[key].quantity++;
      });
      return order.map(function (key) { return grouped[key]; });
    }, includeClub === true);
  }
  function join() {
    if (!cfg.enabled) return Promise.reject(new Error('Club unavailable'));
    return mutate(function () { return []; }, true);
  }
  function teeTotals() {
    var count = 0, sum = 0;
    (cart.items || []).filter(isTee).forEach(function (it) {
      count += it.quantity;
      sum += Math.max(0, it.original_price - cfg.off) * it.quantity;
    });
    return { count: count, member: sum };
  }
  function renderBlocks() {
    var active = member(), pending = hasClub(cart), totals = teeTotals();
    if (active || pending || !cfg.enabled) selected = false;
    document.querySelectorAll('[data-wq-club-offer]').forEach(function (el) { el.hidden = active || pending || !cfg.enabled; });
    document.querySelectorAll('[data-wq-club-join]').forEach(function (el) { el.checked = wantsClub(); el.disabled = mutationBusy || !cfg.enabled || active || pending; });
    document.querySelectorAll('[data-wq-club-member]').forEach(function (el) { el.hidden = !active; });
    document.querySelectorAll('[data-wq-club-pending]').forEach(function (el) { el.hidden = !pending || active; });
    document.querySelectorAll('[data-wq-club-upsell]').forEach(function (el) {
      el.hidden = active || pending || !cfg.enabled || totals.count === 0;
      var button = el.querySelector('[data-wq-club-add]');
      if (button) button.textContent = copy('upsell', { member_total: money(totals.member), club_price: money(cfg.price) });
    });
    document.querySelectorAll('[data-wq-club-page] [data-wq-club-add]').forEach(function (el) {
      el.hidden = active || pending;
      el.textContent = copy('cta', { club_price: money(cfg.price) });
    });
    document.querySelectorAll('[data-wq-club-add]').forEach(function (el) { el.disabled = mutationBusy || !cfg.enabled || active || pending; });
    document.querySelectorAll('[data-wq-club] [data-wq-club-status]').forEach(function (el) {
      if (!cfg.enabled) { el.textContent = cfg.copy.unavailable; el.hidden = false; }
    });
  }
  window.WQClub = {
    enabled: cfg.enabled, isTee: isTee, setCart: setCart, sync: sync,
    memberPricing: memberPricing, member: member,
    off: cfg.off, selected: wantsClub, charge: charge, addTees: addTees, join: join
  };
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-wq-club-join]')) return;
    selected = !!e.target.checked; renderBlocks();
    document.dispatchEvent(new CustomEvent('wq:club-change'));
  });
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-wq-club-add]');
    if (!button || button.disabled) return;
    e.preventDefault();
    var block = button.closest('.wq-club'), status = block && block.querySelector('[data-wq-club-status]');
    button.disabled = true;
    if (status) status.hidden = true;
    join().then(function () {
      if (status) { status.textContent = cfg.copy.added; status.hidden = false; }
      if (document.querySelector('m-cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      else location.href = root + 'cart';
    }).catch(function () {
      button.disabled = false;
      if (status) { status.textContent = cfg.copy.error; status.hidden = false; }
    });
  });
  document.addEventListener('cart:updated', function () { sync().catch(function () {}); });
  document.addEventListener('cart:refresh', function () { sync().catch(function () {}); });
  window.addEventListener('pageshow', function () { sync().catch(function () {}); });
  window.addEventListener('focus', function () { sync().catch(function () {}); });
  // Drawer/cart HTML is replaced by Minimog. Initialise just the new Club blocks.
  new MutationObserver(function (records) {
    if (records.some(function (r) { return Array.prototype.some.call(r.addedNodes, function (node) {
      return node.nodeType === 1 && (node.matches('[data-wq-club-upsell]') || node.querySelector('[data-wq-club-upsell]'));
    }); })) renderBlocks();
  }).observe(document.body, { childList: true, subtree: true });
  renderBlocks();
  sync().catch(function () {});
})();
